import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cuatro_black",
  "use": "cuatro_black-usage",
  "viewBox": "0 0 36 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 32\" id=\"cuatro_black\"><title>Cuatro</title><path d=\"M26.866 18.286c0 7.211-6.017 13.064-13.433 13.064S0 25.497 0 18.286C0 11.073 6.019 5.222 13.433 5.222c7.416-.001 13.434 5.852 13.434 13.064zM36.173 4.803c0 2.556-2.04 4.63-4.554 4.63-2.513 0-4.554-2.074-4.554-4.63 0-2.557 2.041-4.63 4.554-4.63 2.514 0 4.554 2.073 4.554 4.63z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol